import { render, staticRenderFns } from "./SttrL.vue?vue&type=template&id=48e4ac2d"
import script from "./SttrL.vue?vue&type=script&lang=js"
export * from "./SttrL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports